module.exports = __webpack_public_path__ + "img/international-council-of-museums.fa76eabe.png";